import React from 'react'
import FPCategoriesEdit from '../parts/fprivate_cats_edit'
import FPUploads from '../parts/fp_uploads'
import FPrivatePricingEdit from '../parts/fp_pricing_edit'
import HelpOverlay from '../../utils/helpOverlay'
import SelectMultipleValsInput from '../../input/select_multiple'
import VideoIDSEdit from '../parts/fprivate_vid_ids'
import PPRollsTab from '../parts/pprolls_tab'
import { Tabs, Tab } from 'react-bootstrap'

export default class FlyPrivateEditForm extends React.Component {
  changeAttrArrayValue (platform, name, value) {
    this.props.store.changeAttrArrayValue(platform, name, value)
  }

  render () {
    const { store, updateField, disabled, isBundleType, assetTabs } = this.props
    const entity = store.cv.record
    const errors = store.cv.errors
    let ek = 1

    return (
      <div>
        <Tabs defaultActiveKey={assetTabs}
          onSelect={tab => store.assetTabEvent('flyprivate', tab)}
          activeKey={assetTabs}>

          <Tab eventKey={ek++} title={
            <div>
              {store.__('Uploads')}
              <HelpOverlay store={store} path={'films/FP/uploads'} />
            </div>}>
            <FPUploads uploadType='file'
              store={store} disabled={disabled} disabledRemove={disabled} />
          </Tab>
          <Tab eventKey={ek++} title={
            <div>
              {store.__('Subtitles')}
              <HelpOverlay store={store} path={'films/FP/subtitles'} />
            </div>}>
            <FPUploads uploadType='subtitle'
              store={store} disabled={disabled} disabledRemove={disabled} />
          </Tab>
          <Tab eventKey={ek++} title={
            <div>
              {store.__('FlyPrivate pricing')}
              <HelpOverlay store={store} path={'films/FP/pricings'} />
            </div>}>
            <FPrivatePricingEdit
              store={store} disabled={disabled} disabledRemove={disabled} />
          </Tab>
          <Tab eventKey={ek++} title={
            <div>
              {store.__('FlyPrivate categories')}
              <HelpOverlay store={store} path={'films/FP/categories'} />
            </div>}>
            <SelectMultipleValsInput
              store={store} attr={'tags'}
              record={entity} onChange={updateField} optionsrecord={store.options}
              optionsattr={'Tags'} errors={errors} disabled={disabled} />
            <FPCategoriesEdit
              store={store} disabled={disabled} disabledRemove={disabled}
              items={store.cv.record.get('flyprivateCategories')} />
          </Tab>
          <Tab eventKey={ek++} title={
            <div>
              {store.__('Pre/post-rolls')}
              <HelpOverlay store={store} path={'films/FP/pprolls'} />
            </div>}>
            <PPRollsTab store={store} />
          </Tab>

          {!isBundleType && <Tab eventKey={ek++} title={
            <div>
              {store.__('Video IDs')}
              <HelpOverlay store={store} path={'films/FP/videoids'} />
            </div>}>
            <VideoIDSEdit
              store={store} errors={errors} disabled={disabled} disabledRemove={disabled} />
          </Tab>
          }
        </Tabs>

      </div>
    )
  }
}
